import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1741">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1742">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1743">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1744">
          {isOpen ? <XIcon size={24} data-id="element-1745" /> : <PlusIcon size={24} data-id="element-1746" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1747">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1748">
          {answer}
        </p>
      </div>
    </div>;
}
export function PTFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Is The PDO Thread Experience Like?',
    answer: 'Your PDO Thread treatment at our San Ramon & San Francisco Bay Area medical spa clinic will begin with a consultation in which you and your provider will determine your treatment goals. During this minimally invasive procedure, our Injectors will use the most advanced techniques to insert the PDO Threads and lift the skin upwards. Treatment typically only takes 30-45 minutes. Numbing cream is available for all injectable procedures.'
  }, {
    question: 'What To Expect Post Treatment?',
    answer: "If you receive lifting absorbable threads, you will be able to see some lifting effects instantly after the threads are placed. As the PDO Threads sit under the skin, they begin to stimulate collagen production. You'll begin to see a difference in the target areas within weeks, and results will continue to increase for 4-6 months. Side effects may include mild swelling and soreness for 3-5 days after the procedure, and tightness for up to two weeks. Mild dimpling may occur but will resolve within a few days. Side effects depend on the technique of insertion and types of threads used, so choosing a well-trained doctor is an action you can take to protect yourself and ensure excellent results."
  }, {
    question: 'What Are The Most Common Side Effects?',
    answer: "The threads procedure is considered a very safe procedure, with even milder side effects than fillers. PDO Threads are nontoxic and have not been known to cause any type of allergic reaction. The same threads have been used successfully in medicine for closing wounds, gynecology and more. You may have some swelling and bruising for the first 24-48 hours, but recovery from the procedure is minimal and it's often possible to return to work the same day."
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1749">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1750">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1751">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1752">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1753"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1754">
          <div className="space-y-2" data-id="element-1755">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1756" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}